module.exports = __webpack_public_path__ + "img/log.51283cd1.svg";